import { useRecoilState } from 'recoil'
import { authModalAtom } from 'recoil/atom/AuthModalAtom'

const LoginBtnModal = () => {
  const [, setAuthModalValue] = useRecoilState(authModalAtom)

  const onOpenAuthModal = () => {
    setAuthModalValue(prevState => ({
      ...prevState,
      isOpenAuthModal: true,
      authType: 'login',
    }))
  }

  return (
    <a
      href="#"
      id="btn_mo_login"
      className="theme-btn btn-style-one-other"
      data-toggle="modal"
      data-target="#loginFormModal"
      style={{ display: 'none' }}
      onClick={onOpenAuthModal}>
      <span className="txt">เข้าสู่ระบบ</span>
    </a>
  )
}

export default LoginBtnModal
